__webpack_require__.p = "https://lf-lemon8-web.tiktokcdn-us.com/obj/lemon8-web-tx/lemon8_web/legal/default/";